import React, { useEffect, useRef } from "react";

// Phone filters: a "Filters" button (with how many filters are on) that opens a sheet from the bottom.
// Used by All websites, Customers, Franchisees and Manage orders. On wide screens those pages keep their filters
// inline and the button is hidden (admin.css: .filter-btn).

export function FilterButton({ count = 0, onClick }) {
  return (
    <button type="button" className={`filter-btn ${count ? "has-filters" : ""}`} onClick={onClick} aria-haspopup="dialog">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4" /></svg>
      Filters{count > 0 && <b>{count}</b>}
    </button>
  );
}

// resultLabel is the main button's text, e.g. "Show 12 websites"
export function FilterSheet({ title = "Filters", resultLabel, onClose, onReset, children }) {
  // While open the page behind doesn't scroll, and Escape closes it
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") closeRef.current(); };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  return (
    <div className="filter-sheet-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <section className="filter-sheet" role="dialog" aria-modal="true" aria-label={title}>
        <span className="filter-sheet-handle" aria-hidden="true" />
        <div className="filter-sheet-head">
          <h2>{title}</h2>
          <button type="button" onClick={onClose} aria-label="Close filters">✕</button>
        </div>
        <div className="filter-sheet-body">{children}</div>
        <div className="filter-sheet-actions">
          <button type="button" className="outline-btn" onClick={onReset}>Reset</button>
          <button type="button" className="primary-btn" onClick={onClose}>{resultLabel}</button>
        </div>
      </section>
    </div>
  );
}

// One choice from a few options, as tappable chips. An option can carry a colour tone (amber, blue, green, red).
export function FilterChips({ label, options, value, onChange }) {
  return (
    <div className="filter-group">
      <span>{label}</span>
      <div className="filter-chips">
        {options.map((o) => (
          <button type="button" key={o.value} className={`${value === o.value ? "active" : ""} ${o.tone ? `tone-${o.tone}` : ""}`} onClick={() => onChange(o.value)}>
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}

// A labelled select or date input inside the sheet
export function FilterField({ label, children }) {
  return (
    <label className="filter-group">
      <span>{label}</span>
      {children}
    </label>
  );
}
